import { Link } from 'react-router-dom';
import { motion } from 'motion/react';
import { useTranslation } from 'react-i18next';
import { BUSINESS_COPY, resolveUiLanguage } from '../lib/publicCopy';

const LINKS = [
  {
    testId: 'business-compliance',
    to: '/about/compliance',
    copyId: 'compliance',
  },
  {
    testId: 'business-technical',
    to: '/about/technical',
    copyId: 'technical',
  },
  {
    testId: 'business-model',
    to: '/business/model',
    copyId: 'model',
  },
  {
    testId: 'business-pricing',
    to: '/business/pricing',
    copyId: 'pricing',
  },
];

export default function BusinessOverview() {
  const { i18n } = useTranslation();
  const copy = BUSINESS_COPY[resolveUiLanguage(i18n.resolvedLanguage ?? i18n.language)];

  return (
    <main className="tarot-page-motion min-h-screen bg-[#f7f1e8] px-5 py-8 text-[#211b18] sm:px-8">
      <section data-testid="business-overview" className="mx-auto flex min-h-[calc(100vh-4rem)] max-w-6xl flex-col">
        <nav className="flex items-center justify-between gap-3 text-sm">
          <Link to="/" className="text-[#6f625a] hover:text-[#211b18]">← {copy.back}</Link>
          <Link to="/" className="rounded-full bg-[#111] px-4 py-2 font-semibold text-white">
            {copy.trial}
          </Link>
        </nav>

        <div className="grid flex-1 items-center gap-8 py-12 lg:grid-cols-[0.9fr_1.1fr]">
          <motion.header
            initial={{ y: 18, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.55 }}
          >
            <p className="font-mono text-xs uppercase tracking-[0.24em] text-[#9b3b36]">
              {copy.kicker}
            </p>
            <h1 className="mt-4 font-display text-5xl leading-tight sm:text-6xl">
              {copy.title}
            </h1>
            <p className="mt-5 max-w-2xl text-lg leading-relaxed text-[#5f534c]">
              {copy.body}
            </p>
          </motion.header>

          <div className="grid gap-3 sm:grid-cols-2">
            {LINKS.map((item, idx) => {
              const linkCopy = copy.links.find((entry) => entry.id === item.copyId) ?? copy.links[idx];
              return (
              <motion.div
                key={item.to}
                initial={{ y: 18, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ delay: idx * 0.06 }}
              >
                <Link
                  data-testid={item.testId}
                  to={item.to}
                  className="tarot-liquid-glass tarot-shape-spotlight-host flex min-h-[180px] flex-col rounded-2xl border border-[#d9cabe] p-5 text-left transition hover:-translate-y-1 hover:border-[#9b3b36]"
                >
                  <span className="font-mono text-[0.62rem] uppercase tracking-[0.18em] text-[#9b3b36]">
                    {String(idx + 1).padStart(2, '0')}
                  </span>
                  <span className="mt-3 font-display text-3xl text-[#211b18]">{linkCopy.label}</span>
                  <span className="mt-3 text-sm leading-relaxed text-[#5f534c]">{linkCopy.body}</span>
                </Link>
              </motion.div>
              );
            })}
          </div>
        </div>
      </section>
    </main>
  );
}
